var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu__group" }, [
    _c(
      "div",
      {
        staticClass: "menu__group__main",
        class: {
          open: _vm.open,
          active: _vm.group.path && _vm.group.path === _vm.path,
          childActive:
            _vm.group.children &&
            _vm.group.children.some(function(child) {
              return child.path === _vm.path
            })
        },
        on: {
          click: function($event) {
            return _vm.handleClick()
          }
        }
      },
      [
        _c("span", {
          staticClass: "menu__group__icon",
          domProps: { innerHTML: _vm._s(_vm.group.icon) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "menu__title" }, [
          _vm._v(_vm._s(_vm.group.name))
        ]),
        _vm._v(" "),
        !_vm.group.path && _vm.group.children && _vm.group.children.length
          ? _c(
              "svg",
              {
                staticClass: "menu__group__chevron",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "10",
                  height: "6",
                  viewBox: "0 0 10 6",
                  fill: "none"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M4.9907 5.96987C4.90238 5.97194 4.81529 5.94898 4.73947 5.90366C4.66365 5.85832 4.6022 5.79247 4.56223 5.71369L0.108269 0.767593C0.0308976 0.674591 -0.00747058 0.555252 0.00120676 0.434587C0.00988411 0.313923 0.0649332 0.201302 0.154815 0.120331C0.244698 0.0393594 0.362434 -0.00367556 0.483346 0.000246332C0.604259 0.00416822 0.718959 0.0547425 0.803406 0.141369L4.9907 4.79234L9.17721 0.141369C9.26171 0.0547425 9.37639 0.00416822 9.49729 0.000246332C9.61819 -0.00367556 9.73595 0.0393594 9.82583 0.120331C9.91572 0.201302 9.97078 0.313923 9.97947 0.434587C9.98808 0.555252 9.94973 0.674591 9.87235 0.767593L5.41842 5.71145C5.37938 5.78835 5.3198 5.85293 5.24627 5.89802C5.17275 5.9431 5.08818 5.96694 5.00194 5.96688L4.9907 5.96987Z",
                    fill: "currentColor"
                  }
                })
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "menu__list",
        style: {
          height: _vm.open
            ? (_vm.group.children || []).length * 51 + 15 + "px"
            : "0"
        }
      },
      [
        _c(
          "div",
          { staticClass: "menu__list__wrapper" },
          _vm._l(_vm.group.children, function(child, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "menu__item",
                class: { active: child.path && child.path === _vm.path },
                on: {
                  click: function($event) {
                    return _vm.$router.push({ path: child.path })
                  }
                }
              },
              [
                _c("span", { staticClass: "menu__item__title" }, [
                  _vm._v(_vm._s(child.name))
                ])
              ]
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09783f2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09783f2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MenuGroup.vue
// module id = null
// module chunks = 